// extracted by mini-css-extract-plugin
export default {"chooseRoleWrapper":"styles_chooseRoleWrapper__DGOD-","pageTitle":"styles_pageTitle__UbdxI","rolesRow":"styles_rolesRow__FOJew","nextStepBtn":"styles_nextStepBtn__XBlJP"};